import React, { Component } from "react";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import StockUnitTab from "./stockUnitTab";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import service from "../service";
class MasterAcuanStockDetail extends Component {
  constructor(props) {
    super(props);
    this.handleTriggerLoading = this.props.handleTriggerLoading;
    this.isReadonly = [ACTIVITY_TYPE.VIEW, ACTIVITY_TYPE.DELETE].includes(
      this.props.activityType
    );
    this.state = {
      loading: false,
      alertInfo: {
        title: null,
        visible: false,
        content: null,
        activityType: null,
      },
      data: {
        wilayahCode: null,
        dataUnit: [],
        dataPart: [],
      },
      wilayahOptions: [],
      variantOptions: [],
      partOptions: [],
      errors: {},
    };
  }

  componentDidMount() {
    this.loadInitialData();
  }

  loadInitialData = async () => {
    this.handleTriggerLoading();

    let dataDetail = {};
    if (this.props.activityType !== ACTIVITY_TYPE.CREATE) {
      dataDetail = await this.fetchData();
    }

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
        menuName: "Master Acuan Stock",
        setError: this.props.setError,
        args: {
          paramFilters: {
            bizparCategory: "WILAYAH_TYPE",
          },
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
        setError: this.props.setError,
        menuName: "Stock Unit",
        args: {},
      }),
    ];

    const responses = await Promise.all(promises);

    if (responses[0].ok && responses[0].data.status === HttpStatus.SUCCESS) {
      const isCopy = this.props.activityType === ACTIVITY_TYPE.COPY;
      const filteredData =
        !isCopy && !dataDetail?.wilayahCode
          ? responses[0].data.data
          : responses[0].data.data?.filter(
              (item) => item.key !== dataDetail.wilayahCode?.key
            );
      this.setState({
        wilayahOptions: filteredData?.map((option) =>
          mapToObjectDDL(option.value, option.key)
        ),
      });
    }
    if (responses[1].ok && responses[1].data.status === HttpStatus.SUCCESS) {
      this.setState({
        variantOptions: responses[1].data.data,
      });
    }
    this.handleTriggerLoading();
  };

  fetchData = async () => {
    const keyFn =
      this.props.activityType === ACTIVITY_TYPE.COPY
        ? "getCopyMasterAcuanStock"
        : "getDetailMasterAcuanStock";
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")[keyFn],
      menuName: "Master Acuan Stock",
      setError: this.props.setError,
      args: {
        id: this.props.selectedId,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        data: service.constructGetData(res.data.data, this.props.activityType),
      });
      return res.data.data;
    }
    return {};
  };

  fetchDataPart = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart,
      setError: this.props.setError,
      menuName: "Stock Unit",
      args: { paramFilters: { status: "ACTIVE" }, limit: null, page: null },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        partOptions: res.data.data,
      });
    }
    this.handleTriggerLoading();
  };

  fetchDataVariant = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
      setError: this.props.setError,
      menuName: "Stock Unit",
      args: {},
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        variantOptions: res.data.data,
      });
    }
    this.handleTriggerLoading();
  };

  handleAlertInfoVisibility = (title, content, activityType) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title: title,
        content: content,
        activityType: activityType,
      },
    }));
  };

  handleSetState = (callback) => {
    this.setState(callback);
  };

  handleWilayahChange = (value) => {
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        wilayahCode: value,
      },
    }));
  };

  handleValidateSubmit = () => {
    const { data } = this.state;
    const { isValid, wilayahValid, isDataTableExist } =
      service.validateAcuanStockData(data);

    this.setState((prev) => {
      const errors = { ...prev.errors };

      if (!wilayahValid) {
        errors.wilayahCode = "Field wajib diisi";
      } else {
        delete errors.wilayahCode;
      }

      return { ...prev, errors };
    });

    if (!wilayahValid || !isDataTableExist) {
      return;
    }

    if (!isValid) {
      this.handleAlertInfoVisibility(
        "Informasi",
        "Terdapat data acuan stock yang belum disimpan. Silakan simpan atau hapus data terlebih dahulu."
      );
      return;
    }
    this.handleConfirmSubmit();
  };

  handleConfirmSubmit = () => {
    const { data } = this.state;
    const { dataUnit = [], dataPart = [] } = data;

    const confirmationContent = (
      <div style={{ textAlign: "start" }}>
        <p>Acuan stock dengan data:</p>
        <ul>
          <li>{`Acuan Unit: ${dataUnit.length} data`}</li>
          <li>{`Acuan Part: ${dataPart.length} data`}</li>
        </ul>
        <p>akan dibuat. Apakah Anda yakin?</p>
      </div>
    );

    this.handleAlertInfoVisibility("Pertanyaan", confirmationContent, "submit");
  };

  handleSubmit = async () => {
    this.handleTriggerLoading();
    this.handleAlertInfoVisibility();

    const payload = service.constructPayloadSubmit(this.state.data);
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterAcuanStock,
      menuName: "Master Acuan Stock",
      setError: this.props.setError,
      args: payload,
    });

    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.props.onRefresh();
      this.props.onClickClose();
    }
    if (!res.ok) {
      this.handleAlertInfoVisibility("Informasi", res.data.message);
    }
  };

  handleConfirmDelete = () => {
    this.handleAlertInfoVisibility(
      "Pertanyaan",
      "Apakah anda yakin ingin Menghapus data Acuan Stock ini?",
      "delete"
    );
  };

  handleDelete = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterAcuan,
      menuName: "Master Acuan Stock",
      setError: this.props.setError,
      args: {
        id: this.props.selectedId,
      },
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.props.onRefresh();
      this.props.onClickClose();
    }
  };

  handleChangeTab = (index) => {
    if (index === 0) {
      return this.fetchDataVariant();
    }
    this.fetchDataPart();
  };

  handleAcceptAlertInfo = (action) => {
    if (action === "delete") {
      return this.handleDelete();
    } else if (action === "submit") {
      return this.handleSubmit();
    }
    return this.handleAlertInfoVisibility();
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { alertInfo, variantOptions, wilayahOptions, partOptions, data } =
      this.state;

    const renderStockTab = (tab, dataTable) => (
      <StockUnitTab
        {...this.props}
        tab={tab}
        errors={this.state.errors}
        isReadonly={this.isReadonly}
        dataTable={dataTable}
        variantOptions={variantOptions}
        partOptions={partOptions}
        onSetState={this.handleSetState}
        handleAlertInfo={this.handleAlertInfoVisibility}
        handleLoading={this.handleTriggerLoading}
      />
    );

    return (
      <React.Fragment>
        <SimpleModal
          title="Detail Master Acuan Stock"
          visible={visible}
          styles={{ width: "90%" }}
          onClickClose={() => onClickClose()}
          content={
            <ModalContainer>
              <FlexView
                vAlignContent="center"
                style={{
                  justifyContent: "space-between",
                  marginBottom: "25px",
                }}
              >
                <SimpleDDL
                  containerclassname="width width-250px"
                  id="options_wilayah"
                  name="namaWilayah"
                  box="search"
                  mandatory
                  isClearable
                  errorMessage={this.state.errors?.wilayahCode}
                  readOnly={this.isReadonly}
                  options={wilayahOptions}
                  value={data?.wilayahCode}
                  onChange={(value) => this.handleWilayahChange(value)}
                  label="Wilayah"
                />
                <SimpleInput
                  id="id_dokumen_read_only"
                  readOnly
                  label="ID Dokumen"
                  value={data?.documentId}
                />
              </FlexView>
              <Tabs onSelect={this.handleChangeTab}>
                <TabList>
                  <Tab id="button_navigate_unit">ACUAN STOCK UNIT</Tab>
                  <Tab id="button_navigate_part">ACUAN STOCK PART</Tab>
                </TabList>
                <TabPanel>{renderStockTab("unit", data.dataUnit)}</TabPanel>
                <TabPanel>{renderStockTab("part", data.dataPart)}</TabPanel>
              </Tabs>
              <FlexView
                hAlignContent="right"
                className="margin margin-top-25px"
              >
                {[
                  ACTIVITY_TYPE.CREATE,
                  ACTIVITY_TYPE.UPDATE,
                  ACTIVITY_TYPE.COPY,
                ].includes(this.props.activityType) && (
                  <SimpleButton
                    text="Simpan"
                    id="btn_submit"
                    onClick={this.handleValidateSubmit}
                  />
                )}
                {this.props.activityType === ACTIVITY_TYPE.DELETE && (
                  <SimpleButton
                    text="Hapus"
                    id="btn_submit"
                    onClick={this.handleConfirmDelete}
                  />
                )}
              </FlexView>
              {alertInfo.visible && (
                <SimpleAlert
                  visible={alertInfo.visible}
                  title={alertInfo.title}
                  content={alertInfo.content}
                  onClickClose={() => this.handleAlertInfoVisibility()}
                  additionalButtons={
                    alertInfo.activityType === "delete" ||
                    alertInfo.activityType === "submit" ? (
                      <FlexView style={{ gap: "15px" }}>
                        <SimpleButton
                          type="button"
                          text="Tidak"
                          onClick={() => this.handleAlertInfoVisibility()}
                        />
                        <SimpleButton
                          type="button"
                          text="Ya"
                          onClick={() =>
                            this.handleAcceptAlertInfo(alertInfo.activityType)
                          }
                        />
                      </FlexView>
                    ) : (
                      <SimpleButton
                        type="button"
                        text="OK"
                        onClick={() => this.handleAlertInfoVisibility()}
                      />
                    )
                  }
                />
              )}
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default MasterAcuanStockDetail;
